import { useEffect } from 'react';

import { setupFacebookSDK } from '../sdk';

export function useInitFacebookSdk() {
  useEffect(() => {
    setupFacebookSDK().catch((error) => {
      console.error('Facebook SDK initialization failed', error);
    });
  }, []);
}
